export default __webpack_public_path__ + "static/media/seatb.ed5d5f79.png";